import axiosInstance from '../../../../config/axiosInstance';
import { UnitOfMeasureValidation } from "../../views/UnitOfMeasure/Validation/UnitOfMeasureValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (event, formData, setFormData, setErrors,redirectCallback,redirectRoleList) => {

  event.preventDefault();
  const formErrors = UnitOfMeasureValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      const CompanyID=localStorage.getItem("CompanyID");
      formData.ClientID=CompanyID;
      const response = await axiosInstance.post(`/Setup/CreateUnitOfMeasure`, formData);
     setFormData({
        Measurment: '',
        IsDefault:'',
        DecimalPlaces:'',
        
        // Reset other fields as needed
      });
      redirectRoleList();
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };